<template>
  <div id="app" :class="$route.name">
    <aside ref="background" class="aside">
      <router-link 
        :to="{ path: '/' }"
        @mouseenter.native="mouseType = 'hover'" 
        @mouseleave.native="mouseType = 'normal'" 
        class="go-home">
        Home
      </router-link>
      <p class="signature">by Jérôme BOUTASSIME</p>
      <aside class="aside-background"></aside>
      <aside class="aside-line">
        <div class="line line-top"></div>
        <div class="line line-bottom"></div>
      </aside>
    </aside>
    <router-view class="main" @mouse="updateMouseType" @load="updateIsLoaded" @scrollTo="updateScroll" :progress="scrollProgress" :winsize="winsize" :time="time"/>
    <Mouse :size="mousesize" :progress="mouseProgress"/>
  </div>
</template>

<script>
import Mouse from '@/components/Mouse'
import VirtualScroll from 'virtual-scroll'
import { lerp } from './utils/math'

export default {
  components: {
    Mouse
  },
  data() {
    return {
      time: new Date,
      isLoaded: false,
      winsize: {
        width: null,
        height: null
      },
      mousesize: { 
        pointer: 5, 
        circle: 25 
      },
      mousepos: {
        x: null,
        y: null
      },
      mouseType: 'normal',
      mouseProgress: {
        pointer: {
          x: 0,
          y: 0
        },
        circle: {
          x: 0,
          y: 0
        },
        scale: 1
      },
      scroll: null,
      scrollBounds: { 
        height: 0 
      },
      scrollProgress: {
        pourcent: 0,
        px: 0,
        max: 0
      },
      renderedStyles: {
        scrollY: {previous: 0, current: 0, amt: 0.05},
        mouseX: {previous: 0, current: 0, amt: 0.2},
        mouseY: {previous: 0, current: 0, amt: 0.2},
        mouseScale: {previous: 1, current: 1, amt: 0.2}
      },
    }
  },
  watch: {
    mouseType(value) {
      if (value == 'normal') {
        this.renderedStyles['mouseScale'].current = 1
      }

      if (value == 'hover') {
        this.renderedStyles['mouseScale'].current = 1.9
      }
    },
    isLoaded(value) {
      if (value) this.resize()
    }
  },
  mounted() {
    this.init()
    this.resize()
    this.initScroll()
    this.bind()
    this.render()
  },
  methods: {
    init() {
      this.$anime({
        targets: this.$refs.background,
        scale: [1.05, 1],
        opacity: [0, 1],
        duration: 1200,
        delay: 1000,
        easing: 'cubicBezier(0.520, 0.340, 0.005, 0.995)'
      })
    },
    initScroll() {
      document.addEventListener('touchmove', e => e.preventDefault())
      const scroll = new VirtualScroll({el: document})
      scroll.on(({ deltaY }) => {
        if (this.isLoaded) {

          this.renderedStyles['scrollY'].current += deltaY;
          this.renderedStyles['scrollY'].current = Math.max( (this.scrollBounds.height - this.winsize.height) * -1, this.renderedStyles['scrollY'].current);
          this.renderedStyles['scrollY'].current = Math.min(-0.1, this.renderedStyles['scrollY'].current);
        }
      })
    },
    render() {
      for (const key in this.renderedStyles ) {
        this.renderedStyles[key].previous = lerp(this.renderedStyles[key].previous, this.renderedStyles[key].current, this.renderedStyles[key].amt)
      }

      this.scrollProgress = {
        pourcent: (Math.abs(this.renderedStyles['scrollY'].previous)/(this.scrollBounds.height - this.winsize.height))*100,
        px: Math.abs(this.renderedStyles['scrollY'].previous),
        max: this.scrollBounds.height - this.winsize.height
      }

      this.mouseProgress = {
        pointer: {
          x: this.renderedStyles['mouseX'].current,
          y: this.renderedStyles['mouseY'].current,
        },
        circle: {
          x: this.renderedStyles['mouseX'].previous,
          y: this.renderedStyles['mouseY'].previous,
        },
        scale: this.renderedStyles['mouseScale'].previous,
      }

      this.time = new Date()

      requestAnimationFrame(() => this.render())
    },
    resize() {
      let vh = window.innerHeight * 0.01;
      document.documentElement.style.setProperty('--vh', `${vh}px`);

      this.scroll = document.querySelector('.scroll')
      this.winsize = {width: window.innerWidth, height: window.innerHeight}
      this.scrollBounds = this.scroll ? this.scroll.getBoundingClientRect() : this.scrollBounds
    },
    getMousePos(e) {
      let posx = 0
      let posy = 0
      if (!e) e = window.event
      if (e.pageX || e.pageY) {
          posx = e.pageX
          posy = e.pageY
      }
      else if (e.clientX || e.clientY)    {
          posx = e.clientX + document.body.scrollLeft + document.documentElement.scrollLeft
          posy = e.clientY + document.body.scrollTop + document.documentElement.scrollTop
      }
      this.mousepos = { x : posx, y : posy }

      this.renderedStyles['mouseX'].current = this.mousepos.x - this.mousesize.circle/2
      this.renderedStyles['mouseY'].current = this.mousepos.y - this.mousesize.circle/2
    },
    updateMouseType(e) {
      this.mouseType = e
    },
    updateIsLoaded(e) {
      this.isLoaded = e
    },
    updateScroll(e) {
      this.renderedStyles['scrollY'].current = e.y
      if (e.now) this.renderedStyles['scrollY'].previous = e.y
    },
    click() {
      this.renderedStyles['mouseScale'].previous = 0.4;
    },
    routeraftereach(to, from, next) {
      this.scroll = document.querySelector('.scroll')
      this.scrollBounds = this.scroll.getBoundingClientRect()
    },
    bind() {
      window.addEventListener('resize', this.resize)
      window.addEventListener('routeraftereach', this.routeraftereach)
      window.addEventListener('mousemove', ev => this.getMousePos(ev))
      window.addEventListener('click', () => this.click())
    }
  }
}
</script>

<style lang="scss" scoped>
  .aside{
    display: flex;
    align-items: center;
    justify-content: center;
    position: fixed;
    top: 0;
    bottom: 0;
    right: 0;
    left: 0;
    z-index: 0;
    opacity: 0;

    .go-home,
    .signature {
      @extend %subtitle;
      text-decoration: none;
      opacity: 0;
      pointer-events: none;
      position: absolute;
      line-height: $margin;
      left: 50%;
      transform: translateX(-50%);
      white-space: nowrap;
      color: $darkvanilla;
      transition: opacity 1200ms cubic-bezier(0.520, 0.340, 0.005, 0.995);

      .gallery & {
        opacity: 1;
        pointer-events: initial;
      }
    }

    .go-home {
      top: 0;
    }

    .signature {
      bottom: 0;
    }

    &-background {
      @extend %container;
      position: relative;
      height: 100%;
      pointer-events: none;

      &:before,
      &:after {
        content: '';
        position: absolute;
        top: 0;
        bottom: 0;
        width: 1px;
        background-color: $eggshell;
      }

      &:before {
        right: 0;
      }

      &:after {
        left: 0;
      }
    }

    &-line {
      pointer-events: none;
      position: absolute;
      top: 0;
      bottom: 0;
      right: 0;
      left: 0;

      .line {
        position: absolute;
        width: 100%;
        left: 0;
        height: 1px;
        background-color: $eggshell;
        transition: transform 1200ms cubic-bezier(0.520, 0.340, 0.005, 0.995);

        &-top {
          top: $margin;
          transform: translate3d(0, calc(calc(var(--vh, 1vh) * 50) - 120px), 0);

          #app.gallery & {
            transform: translate3d(0, 0, 0);
          }
        }

        &-bottom {
          bottom: $margin;
          transform: translate3d(0, calc(calc(var(--vh, 1vh) * -50) + 121px), 0);

          #app.gallery & {
            transform: translate3d(0, 0, 0);
          }
        }

        @media screen and (min-width: 768px) {
          &-top {
            transform: translate3d(0, calc(calc(var(--vh, 1vh) * 50) - 220px), 0);

            #app.gallery & {
              transform: translate3d(0, 0, 0);
            }
          }

          &-bottom {
            transform: translate3d(0, calc(calc(var(--vh, 1vh) * -50) + 221px), 0);
          }
        }
      }
    }
  }

  .main {
    overflow: hidden;
    position: fixed;
    top: 0;
    left: 0;
    right: 0;
    bottom: 0;
    z-index: 1;

    #app.gallery & {
      top: $margin;
      bottom: $margin;
    }
  }
</style>